class StockTime extends HTMLElement {
    constructor() {
        super();
    }  
    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
    
    connectedCallback() {
        this.id = this.getAttribute('data-id') || 0; 
        const currentVariant = this.getVariantData().find((variant) => { return variant.id === Number(this.id);});
        const data = window.theme.skuProductList || [];
        if(data){ 
            var productInfo = data.find(row => row[0] == currentVariant.sku); 
            if(productInfo){
                this.min = productInfo[1] || 0;
                this.max = productInfo[2] || 0;
            }else{
                this.min = this.getAttribute('data-min') || 0;
                this.max = this.getAttribute('data-max') || 0;
            }
            this.render();        
        }  
    }

    getVariantInventory(variant){
 
        const currentVariant = this.getVariantData().find((product) => { return Number(product.id) === Number(variant.id)});
        const totalRows = window.theme.skuProductList

        var productInfo = totalRows.find(row => row[0] == currentVariant.sku);
        if(productInfo){
            this.min = productInfo[1] || 0;
            this.max = productInfo[2] || 0;
        }else{
            this.min = 0;
            this.max = 0;
        }
        this.render();
    }

    render() {
        if(this.min == 0 && this.max == 0){
            this.style.display = 'none';
        }else{
            this.querySelector(".notify-area-contain p").textContent = `${this.min}-${this.max}`;
            this.querySelector(".notify-area-contain").style.display = 'block';
            this.querySelector(".googoo-type").style.display="block";
            this.style.display= "block";
        }
    }
       
}   

if (!customElements.get('stock-time')) {
    customElements.define('stock-time', StockTime);
}